/* eslint-disable camelcase */
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from "i18next-browser-languagedetector";
import languagePackageEng from './en.json';
import languagePackageFr from './fr.json';

const detectionOptions = {
  order: ['path'],
  lookupFromPathIndex: 0,
  // checkWhitelist: true
}

const dynamicSiteTitle = process.env.REACT_APP_SITE_TITLE || 'YAM Education';

i18next.use(detector).use(initReactI18next).init({
  debug: true,
  detection: detectionOptions,
  fallbackLng: 'en',
  resources: {
    en: {
      //translation: languagePackageEng,
      translation: {
        ...languagePackageEng, // Keep all other translations from en.json
        title: {
          ...languagePackageEng.title, // Keep other specific title keys if they exist
          default: dynamicSiteTitle, // Make "YAM Education" dynamic
          courses: `Courses | ${dynamicSiteTitle}`, // Make "YAM Education" dynamic here
          degrees: `Degrees | ${dynamicSiteTitle}`, // Make "YAM Education" dynamic here
          YAMEducation: dynamicSiteTitle // Make "YAM Education" dynamic
        }
      },
    },
    fr: {
      //translation: languagePackageFr,
      translation: {
        ...languagePackageFr, // Keep all other translations from fr.json
        title: {
          ...languagePackageFr.title, // Keep other specific title keys if they exist
          default: dynamicSiteTitle, // Make "YAM Education" dynamic
          courses: `Cours | ${dynamicSiteTitle}`, // Make "YAM Education" dynamic here
          degrees: `Degrés | ${dynamicSiteTitle}`, // Make "YAM Education" dynamic here
          YAMEducation: dynamicSiteTitle // Make "YAM Education" dynamic
        }
      },
    }
  },
});

export default i18next;
